export const AbortEvent = {
  wheel: 'wheel',
  keydown: 'keydown',
  resize: 'resize'
};